import { Col, Row } from "antd";
import Form from "antd/lib/form";
import Link from "next/link";
import { routes } from "../../../config/route-config";
import {
  emailValidation,
  passwordValidation
} from "../../../lib/validation/InputValidations";
import Button from "../../Shared/Button";
import Input from "../../Shared/Input";
import { useV3HandleLogin } from "./hooks";

const Login = () => {
  const { onFinish, isLoading } = useV3HandleLogin();

  return (
    <Form name="Login" onFinish={onFinish} layout="vertical" title="Login">
      <Row>
        <Col flex="auto">
          <Input
            name="username"
            type="text"
            label="Email"
            placeholder="example@gmail.com"
            rules={emailValidation}
          />
        </Col>
        <Col flex="auto" className="mt-6">
          <div className="flex items-center justify-between mb-[8px]">
            <div className="heading2">Password</div>
            <div>
              <Link href={routes.ForgetPassword.url}>
                <a className="link animate">Forgot password?</a>
              </Link>
            </div>
          </div>
          <Input
            name="password"
            placeholder="***********"
            type="password"
            rules={passwordValidation}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="mt-6">
          <Button
            loading={isLoading}
            type="primary"
            className="mt-5"
            htmlType="submit"
            id="login_button"
          >
            LOGIN
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Login;
